module.exports = __webpack_public_path__ + "img/integral_bg.e6881401.png";